import { Text } from '@kanda-libs/ks-design-library';
import { Form } from '@kanda-libs/ks-component-ts';
import CheckList from 'components/CheckList';
import AcceptTermsInput from 'components/AcceptTermsInput';
import { PROPS } from './constants';
import FormPage from '../../FormPage';
import useAcceptTermsForm from './useAcceptTermsForm';

const AcceptTerms = ({}) => {
  const { form, nextButtonProps, isLoading, onSubmit } = useAcceptTermsForm();
  const innerItemsProps = { isLoading };

  return (
    <Form id="accept-terms" form={form} onSubmit={onSubmit}>
      <FormPage nextButtonProps={nextButtonProps}>
        <Text {...PROPS.title} {...innerItemsProps} />
        <Text {...PROPS.checksTitle} {...innerItemsProps} />
        <CheckList {...PROPS.checks} {...innerItemsProps} />
        <Text {...PROPS.listTitle} {...innerItemsProps} />
        <CheckList {...PROPS.list} {...innerItemsProps} />
        <AcceptTermsInput />
      </FormPage>
    </Form>
  );
};

export default AcceptTerms;
